import { Button, Container, Stack, Text, Title } from "@mantine/core";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/")({
  component: HomePage,
});

function HomePage() {
  return (
    <Container size="md" py="xl">
      <Stack gap="lg">
        <Title order={1}>Welcome to Kablan</Title>
        <Text size="lg" c="dimmed">
          Professional construction project management platform
        </Text>
        <Button size="lg" variant="filled">
          Get Started
        </Button>
      </Stack>
    </Container>
  );
}
